
import Image from '@/components/Image.vue'
import OverviewBox from '@/components/overview/OverviewBox.vue'
import { IResaleBoxData } from '@/__types__/overview'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ResaleBox',
  props: {
    data: {
      type: Object as PropType<IResaleBoxData>,
      required: true,
    },
  },
  components: { OverviewBox, Image },
})
